import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "p-2" };
const _hoisted_2 = { class: "desenfoque pb-4" };
const _hoisted_3 = { class: "d-flex justify-content-between p-4" };
const _hoisted_4 = { class: "bg-fecha" };
const _hoisted_5 = { class: "row px-4 mb-4" };
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = {
    class: /*@__PURE__*/ _normalizeClass({ 'w-50': true, 'mx-auto': true })
};
const _hoisted_8 = { class: "row px-4 mb-4" };
const _hoisted_9 = { class: "col-12" };
const _hoisted_10 = {
    class: /*@__PURE__*/ _normalizeClass({ 'w-50': true, 'mx-auto': true })
};
const _hoisted_11 = {
    key: 0,
    class: "row px-4 mb-4"
};
const _hoisted_12 = { class: "col-12" };
const _hoisted_13 = { class: "q-pl-md w-25" };
const _hoisted_14 = { class: "q-pl-md w-25" };
const _hoisted_15 = { class: "q-pl-md" };
const _hoisted_16 = { class: "q-pl-md" };
const _hoisted_17 = { class: "q-pl-md" };
const _hoisted_18 = { class: "q-pl-md" };
const _hoisted_19 = { class: "q-pl-md" };
const _hoisted_20 = { class: "q-pl-md" };
const _hoisted_21 = { class: "q-pl-md" };
const _hoisted_22 = { class: "q-pl-md" };
const _hoisted_23 = { class: "q-pl-md" };
const _hoisted_24 = { class: "q-pl-md" };
const _hoisted_25 = { class: "q-pl-md" };
const _hoisted_26 = { class: "q-pl-md" };
const _hoisted_27 = { class: "q-pl-md" };
const _hoisted_28 = { class: "q-pl-md" };
const _hoisted_29 = {
    key: 1,
    class: "text-center q-pb-md"
};
const _hoisted_30 = {
    key: 2,
    class: "row px-4 mb-4"
};
const _hoisted_31 = { class: "col-12 mb-4" };
const _hoisted_32 = { class: "text-center w-50" };
const _hoisted_33 = { class: "text-center" };
const _hoisted_34 = { class: "text-center" };
const _hoisted_35 = { class: "col-12 mb-4" };
const _hoisted_36 = { class: "ps-2" };
const _hoisted_37 = { class: "col-12 mb-4" };
const _hoisted_38 = { class: "col-12" };
const _hoisted_39 = {
    key: 3,
    class: "text-center q-pb-md"
};
const _hoisted_40 = { key: 4 };
const _hoisted_41 = { class: "text-center" };
const _hoisted_42 = { class: "px-4 mb-4" };
const _hoisted_43 = {
    key: 5,
    class: "text-center q-pb-md"
};
const _hoisted_44 = { class: "row px-4 mb-4" };
const _hoisted_45 = { class: "col-12 text-center" };
const _hoisted_46 = {
    key: 0,
    class: "d-flex align-items-center justify-content-center"
};
const _hoisted_47 = {
    key: 1,
    class: "d-flex align-items-center justify-content-center"
};
const _hoisted_48 = { key: 6 };
const _hoisted_49 = { class: "row px-4 mb-4" };
const _hoisted_50 = { class: "col-12 overflow-auto mb-3" };
const _hoisted_51 = { class: "w-50 mx-auto" };
const _hoisted_52 = { class: "text-center fs-3 fw-bold w-25 text-no-wrap" };
const _hoisted_53 = { class: "text-center fs-3 fw-bold w-25 text-no-wrap" };
const _hoisted_54 = { class: "text-center fs-3 fw-bold" };
const _hoisted_55 = { class: "text-center fs-3 fw-bold" };
const _hoisted_56 = { class: "text-center fs-3 fw-bold" };
const _hoisted_57 = { class: "text-center fs-3 fw-bold" };
const _hoisted_58 = {
    key: 7,
    class: "text-center q-pb-md"
};
const _hoisted_59 = {
    key: 8,
    class: "px-4 mb-4"
};
const _hoisted_60 = {
    key: 9,
    class: "text-center q-pb-md"
};
const _hoisted_61 = { key: 10 };
const _hoisted_62 = { class: "row px-4 mb-4" };
const _hoisted_63 = { class: "col-12 text-center mb-4" };
const _hoisted_64 = { class: "col-12 text-center" };
const _hoisted_65 = {
    key: 11,
    class: "text-center q-pb-md"
};
const _hoisted_66 = { key: 12 };
const _hoisted_67 = { class: "px-4 mb-4" };
const _hoisted_68 = {
    key: 13,
    class: "text-center q-pb-md"
};
const _hoisted_69 = { key: 14 };
const _hoisted_70 = { class: "px-4 mb-4" };
const _hoisted_71 = {
    key: 15,
    class: "text-center q-pb-md"
};
const _hoisted_72 = { key: 16 };
const _hoisted_73 = { class: "px-4 mb-4" };
const _hoisted_74 = {
    key: 17,
    class: "text-center q-pb-md"
};
const _hoisted_75 = { key: 18 };
const _hoisted_76 = { class: "text-center fw-bold fs-1 px-4 mb-4" };
const _hoisted_77 = { class: "col-12 text-center" };
const _hoisted_78 = {
    key: 19,
    class: "text-center q-pb-md"
};
const _hoisted_79 = { class: "px-4 mb-4" };
const _hoisted_80 = {
    key: 1,
    class: "text-center q-pb-md"
};
const _hoisted_81 = { key: 20 };
const _hoisted_82 = { class: "px-4 mb-4" };
const _hoisted_83 = {
    key: 21,
    class: "text-center q-pb-md"
};
const _hoisted_84 = { key: 22 };
const _hoisted_85 = { class: "px-4 mb-4" };
const _hoisted_86 = { class: "q-pt-md" };
const _hoisted_87 = {
    key: 23,
    class: "text-center q-pb-md"
};
const _hoisted_88 = { key: 24 };
const _hoisted_89 = { class: "px-4 mb-4" };
const _hoisted_90 = {
    key: 25,
    class: "text-center q-pb-md"
};
const _hoisted_91 = { key: 26 };
const _hoisted_92 = { class: "px-4 mb-4" };
const _hoisted_93 = {
    key: 27,
    class: "text-center q-pb-md"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_table_view = _resolveComponent("table-view");
    const _component_deslizar_movil = _resolveComponent("deslizar-movil");
    const _component_contador = _resolveComponent("contador");
    const _component_table_view_historial_crediticio = _resolveComponent("table-view-historial-crediticio");
    const _component_contador_precio = _resolveComponent("contador-precio");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[67] || (_cache[67] = _createElementVNode("div", { class: "py-2 cinta-cabecera" }, [
            _createElementVNode("span", null, "Inicio"),
            _createElementVNode("span", null, "Mantenimientos"),
            _createElementVNode("span", null, "Consultas/Reporte"),
            _createElementVNode("span", null, "Transacción")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("img", {
                    src: "img/logo.webp",
                    height: "50"
                }, null, -1)),
                _createElementVNode("span", _hoisted_4, "Fecha de consulta " + _toDisplayString(_ctx.fechaActual), 1)
            ]),
            _createElementVNode("h4", {
                class: _normalizeClass(["titulo-seccion p-4 mb-4", { 'text-h6': _ctx.xs }])
            }, " REPORTE DE CRÉDITO " + _toDisplayString(_ctx.reporte.tipo_reporte), 3),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                    class: _normalizeClass(["bg-grey-3 text-center fw-bold w-50", { 'mini-texto': _ctx.xs }])
                                }, " Documento de identidad ", 2),
                                _createElementVNode("td", {
                                    class: _normalizeClass(["text-center w-50", { 'mini-texto': _ctx.xs }])
                                }, _toDisplayString(_ctx.reporte.identificacion_cliente), 3)
                            ]),
                            _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                    class: _normalizeClass(["bg-grey-3 text-center fw-bold", { 'mini-texto': _ctx.xs }])
                                }, " Nombres ", 2),
                                _createElementVNode("td", {
                                    class: _normalizeClass(["text-center", { 'mini-texto': _ctx.xs }])
                                }, _toDisplayString(_ctx.reporte.nombres_cliente), 3)
                            ]),
                            _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                    class: _normalizeClass(["bg-grey-3 text-center fw-bold", { 'mini-texto': _ctx.xs }])
                                }, " Edad ", 2),
                                _createElementVNode("td", {
                                    class: _normalizeClass(["text-center", { 'mini-texto': _ctx.xs }])
                                }, _toDisplayString(_ctx.reporte.edad_cliente), 3)
                            ])
                        ])
                    ])
                ])
            ]),
            _createElementVNode("h5", {
                class: _normalizeClass(["titulo-seccion py-2 mb-3", { 'text-h6': _ctx.xs }])
            }, " DATOS DE CONTACTO ", 2),
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("table", _hoisted_10, [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                    class: _normalizeClass(["bg-grey-3 text-center fw-bold w-50", { 'mini-texto': _ctx.xs }])
                                }, " Celular ", 2),
                                _createElementVNode("td", {
                                    class: _normalizeClass(["text-center w-50", { 'mini-texto': _ctx.xs }])
                                }, _toDisplayString(_ctx.reporte.celular_cliente), 3)
                            ]),
                            _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                    class: _normalizeClass(["bg-grey-3 text-center fw-bold", { 'mini-texto': _ctx.xs }])
                                }, " Correo ", 2),
                                _createElementVNode("td", {
                                    class: _normalizeClass(["text-center", { 'mini-texto': _ctx.xs }])
                                }, _toDisplayString(_ctx.reporte.correo_cliente), 3)
                            ]),
                            _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                    class: _normalizeClass(["bg-grey-3 text-center fw-bold", { 'mini-texto': _ctx.xs }])
                                }, " Dirección ", 2),
                                _createElementVNode("td", {
                                    class: _normalizeClass(["text-center", { 'mini-texto': _ctx.xs }])
                                }, _toDisplayString(_ctx.reporte.direccion_cliente), 3)
                            ])
                        ])
                    ])
                ])
            ]),
            _createElementVNode("h5", {
                class: _normalizeClass(["titulo-seccion py-2 mb-3", { 'text-h6': _ctx.xs }])
            }, " INFORMACIÓN LABORAL ", 2),
            (_ctx.reporte.tiene_informacion_laboral)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("table", {
                            class: _normalizeClass({ 'mini-texto': _ctx.xs })
                        }, [
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _cache[1] || (_cache[1] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold w-25" }, " Ruc empleador ", -1)),
                                    _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.reporte.ruc_empleador), 1),
                                    _cache[2] || (_cache[2] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold w-25" }, " Tipo empresa ", -1)),
                                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.reporte.tipo_empresa), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[3] || (_cache[3] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Nombre empresa ", -1)),
                                    _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.reporte.nombre_empresa), 1),
                                    _cache[4] || (_cache[4] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Código sucursal ", -1)),
                                    _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.reporte.codigo_sucursal), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[5] || (_cache[5] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Teléfono sucursal ", -1)),
                                    _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.reporte.telefono_sucursal), 1),
                                    _cache[6] || (_cache[6] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Dirección sucursal ", -1)),
                                    _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.reporte.direccion_sucursal), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[7] || (_cache[7] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Fax sucursal ", -1)),
                                    _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.reporte.fax_sucursal), 1),
                                    _cache[8] || (_cache[8] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Dirección afiliado ", -1)),
                                    _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.reporte.direccion_afiliado), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[9] || (_cache[9] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Teléfono afiliado ", -1)),
                                    _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.reporte.telefono_afiliado), 1),
                                    _cache[10] || (_cache[10] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Ocupación afiliado ", -1)),
                                    _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.reporte.ocupacion_afiliado), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[11] || (_cache[11] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Celular afiliado ", -1)),
                                    _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.reporte.celular_afiliado), 1),
                                    _cache[12] || (_cache[12] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Email afiliado ", -1)),
                                    _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.reporte.email_afiliado), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[13] || (_cache[13] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Salario afiliado ", -1)),
                                    _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.reporte.salario_afiliado), 1),
                                    _cache[14] || (_cache[14] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Fecha ingreso ", -1)),
                                    _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.reporte.fecha_ingreso), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[15] || (_cache[15] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Fecha salida ", -1)),
                                    _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.reporte.fecha_salida), 1),
                                    _cache[16] || (_cache[16] = _createElementVNode("td", { class: "bg-grey-3 q-pl-md fw-bold" }, " Ubicación empresa ", -1)),
                                    _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.reporte.ubicacion_empresa), 1)
                                ])
                            ])
                        ], 2)
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_29, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[17] || (_cache[17] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[47] || (_cache[47] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, " SERVICIO DE RENTAS INTERNAS (SRI) ", -1)),
            (_ctx.reporte.tiene_ruc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("table", null, [
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _cache[18] || (_cache[18] = _createElementVNode("td", { class: "bg-grey-3 text-center fw-bold w-50" }, " RUC ", -1)),
                                    _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.reporte.ruc_cliente), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[19] || (_cache[19] = _createElementVNode("td", { class: "bg-grey-3 text-center fw-bold" }, " Razón social ", -1)),
                                    _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.reporte.razon_social), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[20] || (_cache[20] = _createElementVNode("td", { class: "bg-grey-3 text-center fw-bold" }, " Estado contribuyente en el RUC ", -1)),
                                    _createElementVNode("td", _hoisted_34, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass({
                                                'text-positive': _ctx.reporte.estado_contribuyente,
                                                'text-negative': !_ctx.reporte.estado_contribuyente,
                                            })
                                        }, [
                                            _createElementVNode("b", null, _toDisplayString(_ctx.reporte.estado_contribuyente
                                                ? "ACTIVO"
                                                : "NO ACTIVO"), 1)
                                        ], 2)
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "page-break" }, null, -1)),
                    _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("table", null, [
                            _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Tipo de contribuyente"),
                                    _createElementVNode("th", null, "Clase de contribuyente"),
                                    _createElementVNode("th", null, "Obligado a llevar contabilidad")
                                ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, _toDisplayString(_ctx.reporte.tipo_contribuyente), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.reporte.clase_contribuyente), 1),
                                    _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.reporte.obligado_llevar_contabilidad
                                        ? "SI"
                                        : "NO"), 1)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("table", null, [
                            _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Fecha inicio de actividades"),
                                    _createElementVNode("th", null, "Fecha actualización"),
                                    _createElementVNode("th", null, "Fecha cese actividades"),
                                    _createElementVNode("th", null, "Fecha reinicio actividades")
                                ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, _toDisplayString(_ctx.reporte.fecha_inicio_actividades), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.reporte.fecha_actualización), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.reporte.fecha_cese_actividades), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.reporte.fecha_reinicio_actividades), 1)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_table_view, {
                            "configuracion-columnas": _ctx.configuracionColumnasActividades,
                            elementos: _ctx.reporte.actividadesEconomicas
                        }, null, 8, ["configuracion-columnas", "elementos"])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_39, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[24] || (_cache[24] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[48] || (_cache[48] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, "ESTABLECIMIENTO MATRIZ", -1)),
            (_ctx.reporte.tiene_establecimientos)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("p", _hoisted_41, " Lista de establecimientos - " + _toDisplayString(_ctx.totalEstablecimientos) + " registro(s) ", 1),
                    _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_table_view, {
                            "configuracion-columnas": _ctx.configuracionColumnasEstablecimientos,
                            elementos: _ctx.reporte.establecimientos
                        }, null, 8, ["configuracion-columnas", "elementos"])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_43, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[25] || (_cache[25] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[49] || (_cache[49] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, "DECRETO 333", -1)),
            _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                    (_ctx.reporte.beneficiado_333)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                            _createVNode(_component_q_icon, {
                                name: "bi-check-circle-fill",
                                class: "q-mr-sm",
                                color: "positive",
                                size: "sm"
                            }),
                            _cache[26] || (_cache[26] = _createTextVNode("USTED ES BENEFICIADO DEL DECRETO 333"))
                        ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_47, [
                            _createVNode(_component_q_icon, {
                                name: "bi-x-circle-fill",
                                class: "q-mr-sm",
                                color: "negative",
                                size: "sm"
                            }),
                            _cache[27] || (_cache[27] = _createTextVNode("USTED NO HA SIDO BENEFICIADO DEL DECRETO 333"))
                        ]))
                ])
            ]),
            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "page-break" }, null, -1)),
            _cache[51] || (_cache[51] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, "RESUMEN", -1)),
            (_ctx.reporte.tiene_resumen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("table", _hoisted_51, [
                                _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                        _cache[28] || (_cache[28] = _createElementVNode("td", { class: "ps-2 bg-grey-3 fw-bold w-25 text-no-wrap" }, " Saldo total operaciones impagos ", -1)),
                                        _createElementVNode("td", _hoisted_52, " $ " + _toDisplayString(_ctx.reporte.saldo_impagos), 1),
                                        _cache[29] || (_cache[29] = _createElementVNode("td", { class: "ps-2 bg-grey-3 fw-bold w-25 text-no-wrap" }, " Total operaciones impagos ", -1)),
                                        _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.reporte.total_impagos), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                        _cache[30] || (_cache[30] = _createElementVNode("td", { class: "ps-2 bg-grey-3 fw-bold text-no-wrap" }, " Saldo total operaciones demanda judicial ", -1)),
                                        _createElementVNode("td", _hoisted_54, " $ " + _toDisplayString(_ctx.reporte.saldo_demanda_judicial), 1),
                                        _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ps-2 bg-grey-3 fw-bold text-no-wrap" }, " Total operaciones demanda judicial ", -1)),
                                        _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.reporte.total_demanda_judicial), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                        _cache[32] || (_cache[32] = _createElementVNode("td", { class: "ps-2 bg-grey-3 fw-bold text-no-wrap" }, " Saldo total operaciones cartera castigada ", -1)),
                                        _createElementVNode("td", _hoisted_56, " $ " + _toDisplayString(_ctx.reporte.saldo_cartera_castigada), 1),
                                        _cache[33] || (_cache[33] = _createElementVNode("td", { class: "ps-2 bg-grey-3 fw-bold text-no-wrap" }, " Total operaciones cartera castigada ", -1)),
                                        _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.reporte.total_cartera_castigada), 1)
                                    ])
                                ])
                            ])
                        ]),
                        _createVNode(_component_deslizar_movil)
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_58, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[34] || (_cache[34] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[52] || (_cache[52] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, " TOTAL DE DEUDA REPORTADA A LA CENTRAL DE RIESGOS ", -1)),
            (_ctx.reporte.tiene_resumen_morosidades)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createVNode(_component_table_view, {
                        "configuracion-columnas": _ctx.configuracionColumnasMorosidades,
                        elementos: _ctx.reporte.morosidades
                    }, null, 8, ["configuracion-columnas", "elementos"])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_60, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[35] || (_cache[35] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[53] || (_cache[53] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, "SCORES", -1)),
            (_ctx.reporte.tiene_puntuaciones)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                            _createVNode(_component_contador, {
                                titulo: "Score crediticio",
                                valor: _ctx.reporte.score_crediticio ?? 10
                            }, null, 8, ["valor"])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_contador, {
                                titulo: "Score sobreendeudamiento",
                                valor: _ctx.reporte.score_sobreendeudamiento ?? 10
                            }, null, 8, ["valor"])
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_65, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[36] || (_cache[36] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[54] || (_cache[54] = _createElementVNode("div", { class: "page-break" }, null, -1)),
            _cache[55] || (_cache[55] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, " OPERACIONES DE CRÉDITO BANCARIAS ", -1)),
            (_ctx.reporte.tiene_operaciones_credito_bancarias)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_table_view, {
                            "configuracion-columnas": _ctx.configuracionColumnasOperacionesCredito,
                            elementos: _ctx.reporte.operacionesCreditoBancarias,
                            dense: true
                        }, null, 8, ["configuracion-columnas", "elementos"])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_68, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[37] || (_cache[37] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[56] || (_cache[56] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, " OPERACIONES DE CRÉDITO COMERCIALES ", -1)),
            (_ctx.reporte.tiene_operaciones_credito_comerciales)
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_table_view, {
                            "configuracion-columnas": _ctx.configuracionColumnasOperacionesCredito,
                            elementos: _ctx.reporte.operacionesCreditoComerciales,
                            dense: true
                        }, null, 8, ["configuracion-columnas", "elementos"])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_71, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[38] || (_cache[38] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[57] || (_cache[57] = _createStaticVNode("<div class=\"page-break\" data-v-37f2d984></div><h5 class=\"titulo-seccion py-2 mb-3\" data-v-37f2d984>SEGMENTACIÓN DE RIESGO</h5><div class=\"px-4 mb-5\" data-v-37f2d984><table class=\"table\" data-v-37f2d984><thead data-v-37f2d984><tr data-v-37f2d984><th data-v-37f2d984>Segmentación</th><th data-v-37f2d984>Score</th></tr></thead><tbody data-v-37f2d984><tr style=\"background-color:#0cdd77;\" data-v-37f2d984><td data-v-37f2d984>AAA - Cliente excelente</td><td data-v-37f2d984>930 - 999 puntos</td></tr><tr style=\"background-color:#beff6f;\" data-v-37f2d984><td data-v-37f2d984>AA - Cliente bueno</td><td data-v-37f2d984>850 - 929</td></tr><tr style=\"background-color:#f7fee7;\" data-v-37f2d984><td data-v-37f2d984>A - Cliente regular</td><td data-v-37f2d984>700 - 849</td></tr><tr style=\"background-color:#fef200;\" data-v-37f2d984><td data-v-37f2d984>B - Cliente bajo</td><td data-v-37f2d984>400 - 699</td></tr><tr style=\"background-color:#ff0600;\" data-v-37f2d984><td data-v-37f2d984>C - Cliente malo</td><td data-v-37f2d984>Bajo 400</td></tr></tbody></table></div><h5 class=\"titulo-seccion py-2 mb-3\" data-v-37f2d984> HISTORIAL CREDITICIO PERÍODO 3 ÚLTIMOS AÑOS </h5>", 4)),
            (_ctx.reporte.tiene_historial)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_table_view_historial_crediticio, {
                            "configuracion-columnas": _ctx.configuracionColumnasHistorialCrediticio,
                            elementos: _ctx.reporte.historialCrediticio
                        }, null, 8, ["configuracion-columnas", "elementos"])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_74, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[39] || (_cache[39] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[58] || (_cache[58] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, " CUOTA MENSUAL BURÓ DE CRÉDITO ", -1)),
            (_ctx.reporte.tiene_cuota_mensual)
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_contador_precio, {
                                titulo: "Cuota",
                                valor: _ctx.reporte.cuota_mensual
                            }, null, 8, ["valor"])
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_78, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[40] || (_cache[40] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "page-break" }, null, -1)),
            _cache[60] || (_cache[60] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, " INSTITUCIONES QUE HAN REVISADO SU BURÓ DE CRÉDITO ", -1)),
            _createElementVNode("div", _hoisted_79, [
                (_ctx.reporte.tiene_consultas)
                    ? (_openBlock(), _createBlock(_component_table_view, {
                        key: 0,
                        "configuracion-columnas": _ctx.configuracionColumnasConsultasCliente,
                        elementos: _ctx.reporte.consultasCliente,
                        estilos: "w-50 mx-auto"
                    }, null, 8, ["configuracion-columnas", "elementos"]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_80, [
                        _createVNode(_component_q_icon, {
                            name: "bi-info-circle-fill",
                            class: "q-mr-sm",
                            color: "info",
                            size: "sm"
                        }),
                        _cache[41] || (_cache[41] = _createTextVNode("CLIENTE NO POSEE CONSULTAS EN EL ÚLTIMO AÑO FISCAL "))
                    ]))
            ]),
            _cache[61] || (_cache[61] = _createElementVNode("div", { class: "page-break" }, null, -1)),
            _cache[62] || (_cache[62] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, "RESUMEN DE VENCIMIENTOS", -1)),
            (_ctx.reporte.tiene_resumen_vencimientos)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                        _createVNode(_component_table_view, {
                            "configuracion-columnas": _ctx.configuracionColumnasVencimientos,
                            elementos: _ctx.reporte.vencimientos
                        }, null, 8, ["configuracion-columnas", "elementos"])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_83, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[42] || (_cache[42] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[63] || (_cache[63] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, " ANÁLISIS DE SALDOS POR VENCER SISTEMA FINANCIERO ", -1)),
            (_ctx.reporte.tiene_saldos_por_vencer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                        _createVNode(_component_table_view, {
                            "configuracion-columnas": _ctx.configuracionColumnasSaldosPorVencer,
                            elementos: _ctx.reporte.saldosPorVencer
                        }, null, 8, ["configuracion-columnas", "elementos"]),
                        _createElementVNode("p", _hoisted_86, [
                            _cache[43] || (_cache[43] = _createElementVNode("b", null, "Mantiene historial crediticio desde: ", -1)),
                            _createTextVNode(_toDisplayString(_ctx.reporte.historial_crediticio_desde), 1)
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_87, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[44] || (_cache[44] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[64] || (_cache[64] = _createElementVNode("div", { class: "page-break" }, null, -1)),
            _cache[65] || (_cache[65] = _createElementVNode("h5", { class: "titulo-seccion py-2 mb-3" }, " ÚLTIMAS 10 OPERACIONES CANCELADAS ", -1)),
            (_ctx.reporte.tiene_operaciones_canceladas)
                ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                        _createVNode(_component_table_view, {
                            "configuracion-columnas": _ctx.configuracionColumnasOperacionesCanceladas,
                            elementos: _ctx.reporte.operacionesCanceladas
                        }, null, 8, ["configuracion-columnas", "elementos"])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_90, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[45] || (_cache[45] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ])),
            _cache[66] || (_cache[66] = _createElementVNode("h5", { class: "fw-bold text-center" }, "INFORMACIÓN DE SEGUROS", -1)),
            (_ctx.reporte.tiene_informacion_seguros)
                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                        _createVNode(_component_table_view, {
                            "configuracion-columnas": _ctx.configuracionColumnasSeguros,
                            elementos: _ctx.reporte.seguros
                        }, null, 8, ["configuracion-columnas", "elementos"])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_93, [
                    _createVNode(_component_q_icon, {
                        name: "bi-info-circle-fill",
                        class: "q-mr-sm",
                        color: "info",
                        size: "sm"
                    }),
                    _cache[46] || (_cache[46] = _createTextVNode("EL CLIENTE NO POSEE DATOS PARA EL SEGMENTO "))
                ]))
        ])
    ]));
}
